<div class="hidden lg:block px-2">
  <a routerLink="/"><img src="assets/images/Alawneh-Logo-side.png" class="mx-auto" alt="'LOGIN.LOGO_ALT' | translate" /></a>
</div>

<nav class="flex-1 sm:mx-6 mx-3 lg:mt-16 mt-10">
  <ul>
    <li *ngFor="let link of sidebarService.links()">
      <app-navlink [label]="link.label | translate" [route]="link.route" [action]="link.action" [variant]="link.variant"
        [iconPath]="link.iconPath">
      </app-navlink>
    </li>
  </ul>
</nav>